/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.controllers.module.ts" />
/// <reference path="../../common/iapirequestconfig.ts" />
/// <reference path="controllerbase.ts" />
/// <reference path="imodaldialogcontroller.d.ts" />

module App.Common.Controllers {
    'use strict';

    export abstract class ModalDialogControllerBase extends ControllerBase implements IModalDialogController {



        constructor(public $injector: angular.auto.IInjectorService,
            private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
            protected modalConfig: ModalDialogConfig,
            private $uibModalStack: angular.ui.bootstrap.IModalStackService) {
            super($injector);

            this.$rootScope.$on('$stateChangeStart', event => {


                if (angular.isDefined($uibModalStack)) {

                    //get the popup
                    var top = $uibModalStack.getTop();

                    if (angular.isDefined(top) && top != null) {

                        //get the main form on the popup
                        var modelForm = top.value.modalScope[top.value.modalScope.vm.mainFormName()];

                        //errors on the main form of the popup?
                        if (modelForm != null && modelForm.$submitted && modelForm.$invalid) {
                            console.log('preventing....');
                            //prevent closing 
                            event.preventDefault();
                        } else {
                            //otherwise close			
                            $uibModalStack.dismiss(top.key);
                        }
                    }
                }
            });
        }

        public close(result?: any): angular.IPromise<any> {

            var deferred = this.$q.defer();

            if (this.modalConfig.onClosing && _.isFunction(this.modalConfig.onClosing)) {
                return this.modalConfig.onClosing(result)
                    .then(() => {
                        this.closeModal(result);
                        deferred.resolve(result);
                    },
                    () => {
                        deferred.reject(result);
                    });
            } else {
                this.closeModal(result);
                deferred.resolve(result);
            }

            return deferred.promise;
        }

        public dismiss(result?: any): angular.IPromise<any> {

            var deferred = this.$q.defer();

            if (this.modalConfig.onDismissing && _.isFunction(this.modalConfig.onDismissing)) {
                return this.modalConfig.onDismissing(result)
                    .then(() => {
                        this.dismissModal(result);
                        deferred.resolve(result);
                    },
                    () => {
                        deferred.reject(result);
                    });
            } else {
                this.dismissModal(result);
                deferred.resolve(result);
            }
            function silenceUncaughtInPromise(promise) {
                return promise.then(undefined,  () =>{ }) && promise;
            }

            return silenceUncaughtInPromise(deferred.promise);
        }

        private closeModal(result: any) {
            this.$uibModalInstance.close(result);
            if (this.modalConfig.onClose && _.isFunction(this.modalConfig.onClose)) {
                this.modalConfig.onClose(result);
            }
        }

        private dismissModal(result?: any) {
            this.$uibModalInstance.dismiss(result);
            if (this.modalConfig.onDismiss && _.isFunction(this.modalConfig.onDismiss)) {
                this.modalConfig.onDismiss(result);
            }
        }

        public isReadonly() {
            return false; //this.modalConfig.screenMode === ScreenMode.Readonly;
        }

        public canSave(): boolean {
            return this.mainForm().$dirty && !this.isReadonly();
        }

        //This must be unique for each popup which may appear on the screen at the same time
        public abstract mainFormName(): string;

        protected mainFormElement(): angular.IAugmentedJQuery {
            const el = angular.element($(`form[name=${this.mainFormName()}]`));
            return el.length ? el : null;
        }

        protected mainFormScope(): angular.IScope {
            const el = this.mainFormElement();
            if (!el) {
                return null;
            }
            return el.scope();
        }

        protected mainForm(): angular.IFormController {
            const scope = this.mainFormScope();
            if (!scope) {
                return null;
            }
            return scope[this.mainFormName()];
        }

    }

}